/**
 * @generated SignedSource<<d8834b0cd31c066b6d82fc1d593b1bcc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserGuildMembershipsMembersSection_user$data = {
  readonly guildMemberships: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string | null | undefined;
      readonly node: {
        readonly guild: {
          readonly " $fragmentSpreads": FragmentRefs<"GuildCardNew_guild">;
        } | null | undefined;
      } | null | undefined;
    }>;
  };
  readonly id: string;
  readonly " $fragmentType": "UserGuildMembershipsMembersSection_user";
};
export type UserGuildMembershipsMembersSection_user$key = {
  readonly " $data"?: UserGuildMembershipsMembersSection_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserGuildMembershipsMembersSection_user">;
};

import UserGuildMembershipsMembersSectionPaginationQuery_graphql from './UserGuildMembershipsMembersSectionPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "guildMemberships"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": UserGuildMembershipsMembersSectionPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "UserGuildMembershipsMembersSection_user",
  "selections": [
    {
      "alias": "guildMemberships",
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "membershipLevel": "MEMBER"
          }
        }
      ],
      "concreteType": "GuildMembershipsConnection",
      "kind": "LinkedField",
      "name": "__UserGuildMembershipsMembersSection_user_guildMemberships_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GuildMembershipsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GuildMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Guild",
                  "kind": "LinkedField",
                  "name": "guild",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "GuildCardNew_guild"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__UserGuildMembershipsMembersSection_user_guildMemberships_connection(condition:{\"membershipLevel\":\"MEMBER\"})"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "865d30f9544c827fe4b7bf5ef673e39e";

export default node;
